import {
	BookOpenCheckIcon,
	BookOpenIcon,
	ChevronRightIcon,
	GlobeIcon,
	ShieldCheckIcon,
	TicketIcon,
	UsersIcon,
} from "lucide-react";
import Image from "next/image";
import Link from "next/link";

const features = [
	{
		title: "Affordable Employee Benefit",
		description:
			"Provide unlimited pre-approved continuing education credits and 3 certifications for your staff.",
		links: [
			{
				href: "/articles/easy-continuing-education-credits-accreditation",
				label: "CEC Approvals",
			},
		],
		icon: ShieldCheckIcon,
		thumbnailUrl:
			"https://vczc4mkjnoo13s0s.public.blob.vercel-storage.com/home-why-1.jpeg",
	},
	{
		title: "Attract, retain, and promote top talent",
		description:
			"Great professionals want to learn; show them your organization prioritizes employee education.",
		links: [
			{
				href: "https://www.google.com/maps/place/Brookbush+Institute/@40.7470886,-73.9793827,17z/data=!3m1!5s0x89c259042bc3f44d:0xcfda66d9ec348ef6!4m8!3m7!1s0x89c2599677c1a285:0x806ee51940b04b1d!8m2!3d40.7470846!4d-73.9768078!9m1!1b1!16s%2Fg%2F11pck_nqml?entry=ttu",
				label: "Google Reviews",
			},
		],
		icon: UsersIcon,
		thumbnailUrl:
			"https://vczc4mkjnoo13s0s.public.blob.vercel-storage.com/home-why-2.jpeg",
	},
	{
		title: "Skill Acquisition",
		description:
			"200+ courses, 500+ videos, Monthly Webinars, an AI Tutor, and so much more.",
		links: [],
		icon: BookOpenIcon,
		thumbnailUrl:
			"https://vczc4mkjnoo13s0s.public.blob.vercel-storage.com/home-why-3.jpeg",
	},
	{
		title: "Accurate Information",
		description:
			"The Brookbush Institute is the only organization that builds every course from comprehensive systematic research review to ensure unprecedented levels of accuracy.",
		links: [],
		icon: BookOpenCheckIcon,
		thumbnailUrl:
			"https://vczc4mkjnoo13s0s.public.blob.vercel-storage.com/home-why-4.png",
	},
	{
		title: "Speak the Same Language",
		description:
			"Unlike other membership platforms, all Brookbush Institute courses have been developed by our internal staff, who are committed to ensuring a congruent library of clear and engaging courses.",
		links: [],
		icon: GlobeIcon,
		thumbnailUrl:
			"https://cdn.sanity.io/images/obhirpvy/production/28ff1101af4a22191fd938d3f1a31c17364157db-1200x800.jpg",
	},
	{
		title: "Discounted Rates",
		description:
			"Teams get discounts on the already affordable monthly and yearly memberships for BrookbushInstitute.com",
		links: [
			{
				href: "/articles/Cost-of-Personal-Training-Certification",
				label: "Compare Cost",
			},
		],
		icon: TicketIcon,
		thumbnailUrl:
			"https://cdn.sanity.io/images/obhirpvy/production/0b3cce6ff2598af4f1beb6477cbc9585cd6a00c2-1501x986.png",
	},
];

const TeamMembershipFeaturesCard = () => {
	return (
		<section className="container mx-auto my-12 flex flex-col items-center gap-12">
			<h3 className="text-center font-bold text-3xl dark:text-white">
				Why choose Brookbush Institute for your team
			</h3>

			<div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
				{features.map((feature) => (
					<div
						key={feature.title}
						className="flex flex-col justify-between gap-5 rounded-lg bg-slate-50 p-6 dark:bg-slate-700"
					>
						<div className="flex flex-col gap-2">
							{feature.icon && (
								<feature.icon className="h-6 w-6 text-sky-600 dark:text-sky-400" />
							)}
							<h4 className="font-semibold text-xl dark:text-white">
								{feature.title}
							</h4>
							<p className="dark:text-slate-300">{feature.description}</p>
							{!!feature.links.length && (
								<ul className="flex flex-col gap-1.5">
									{feature.links.map((link) => (
										<li key={link.href}>
											<Link
												href={link.href}
												className="flex items-center text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300"
											>
												{link.label}
												<ChevronRightIcon className="-mr-1 h-4 w-4" />
											</Link>
										</li>
									))}
								</ul>
							)}
						</div>

						<div className="relative -mb-2 aspect-video w-full overflow-hidden rounded-xl">
							<Image
								src={feature.thumbnailUrl}
								fill
								alt={feature.title + " thumbnail"}
								className="object-cover"
							/>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default TeamMembershipFeaturesCard;
